import auth from './auth.module';
import alerts from './alerts.module';

export default { auth, alerts };
